import { createV3Queries } from "@query/utils/createV3Queries";
import { payrollsApi } from "@api";

export const queriesPayrolls = createV3Queries("payrollsApi", payrollsApi);
